import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModuleModule } from "src/app/shared/shared-module/shared-module.module";
import { AttachmentsComponent } from "./attachments.component";


@NgModule({
  imports: [CommonModule, SharedModuleModule],
  declarations: [AttachmentsComponent],
  exports: [AttachmentsComponent],

})
export class AttachmentsModule { 
  static component = AttachmentsComponent
}